/**
 * JS pro zascrolování na první chybu ve formuláři.
 * Aby stránka nezůstala nahoře a uživatel věděl o tom, že je ve formuláři nějaká chyba.
 *
 * Stačí do formuláře přidat data atribut data-scroll-to-error
 */

let scrolled = false;

function scrollToFormError(container) {
	if (scrolled === true) {
		return;
	}

	let form = container.querySelector('[data-scroll-to-error]');
	if (form === null) {
		return;
	}

	let error = form.querySelector('.invalid-feedback') || form.querySelector('.error');
	if (error === null || error.parentElement === null) {
		return;
	}

	let y = error.parentElement.getBoundingClientRect().top + window.scrollY - 100;
	window.scrollTo({ top: y, behavior: 'smooth' });

	scrolled = true;
	// po 2 vteřinách nastavíme scrolled na false, aby při dalším ajax requestu došlo ke scrolování
	setTimeout(() => {
		scrolled = false;
	}, 2000);
}

export default function () {
	$.nette.ext('scroll-to-form-error', {
		init: function () {
			scrollToFormError(document);

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					scrollToFormError($el.get(0));
				}
			});
		}
	});
}
